var _defs, _rect, _path, _path2, _path3, _path4, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgMintPaper(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    viewBox: "0 0 1280 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1280,
    y2: 720,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FBFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF5F1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 14,
    floodColor: "#0F172A",
    floodOpacity: 0.18
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H138V720H0V0Z",
    fill: "#0B8E5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68 0H178V720H68V0Z",
    fill: "#18A66A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134 0H244V720H134V0Z",
    fill: "#E8F1ED",
    filter: "url(#shadow)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192 0H268V720H192V0Z",
    fill: "#FFFFFF",
    filter: "url(#shadow)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 0,
    width: 988,
    height: 720,
    fill: "#FAFBFA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 0,
    width: 180,
    height: 720,
    fill: "#F2F5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgMintPaper);
export default __webpack_public_path__ + "static/media/bg-mint-paper.9151f20bf796cc3cbc7c332ed08fbb79.svg";
export { ForwardRef as ReactComponent };